import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ItemMaster, ItemSearchCommand } from '../../models/item/item-master';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { map, Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class ItemMasterProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/item';

  public getAll(): Observable<ApiResponse<ItemMaster[]>> {
    return this.httpClient.get<ApiResponse<ItemMaster[]>>(`${this.baseUrl}/all`);
  }

  public getByItemCodes(itemCodes: string[]): Observable<ApiResponse<ItemMaster[]>> {
    const command = {
      itemCodes: itemCodes,
    };
    return this.httpClient.post<ApiResponse<ItemMaster[]>>(`${this.baseUrl}/item-codes/batch`, command);
  }

  public search(
    searchCommand: ItemSearchCommand,
    matchAny = false,
    consumableOnly = false,
    includeInactive = false,
  ): Observable<ApiResponse<PaginatedApiResponse<ItemMaster>>> {
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<ItemMaster>>>(
      `${this.baseUrl}/search?matchAny=${matchAny}&consumableOnly=${consumableOnly}&includeInactive=${includeInactive}`,
      searchCommand,
    );
  }
}
